import { TodoDtoWithMember } from './docket-types';
import ScrollableTable from './ScrollableTable';
import FollowUpItemTableRow from './follow-up-item-table-row';
import { HeaderCellConfig } from 'toolkit/tables/types/header.types';
import { MenuItemConfig } from 'toolkit/tables/types/menu.types';
import { PaginationBounds } from 'toolkit/tables/types/table.types';

// --- Type Definitions ---
export type FOLLOW_UP_HEADERS =
  | 'id'
  | 'type'
  | 'requiredAction'
  | 'createdAt'
  | 'status';

// This configuration is derived directly from your original component's static array
const headerCells: HeaderCellConfig<FOLLOW_UP_HEADERS>[] = [
  { key: 'id', label: 'Member', sortable: true },
  { key: 'status', label: 'Status', sortable: true },
  { key: 'type', label: 'Event', sortable: true },
  { key: 'requiredAction', label: 'Task', sortable: true },
  { key: 'createdAt', label: 'Date / time', sortable: true },
  { key: 'menu', width: 5 },
  { key: 'toFeed', width: 5 },
];

// --- Component Props Definition ---

interface DocketFollowUpTableViewProps {
  events: TodoDtoWithMember[];
  totalRecords: number;
  bounds: PaginationBounds;
  menuItems: MenuItemConfig<TodoDtoWithMember>[];
  handleTableChange: (changes: {
    orderBy: FOLLOW_UP_HEADERS;
    orderDirection: 'asc' | 'desc';
    pageSize: number;
    pageStart: number;
  }) => void;
  setBounds: React.Dispatch<React.SetStateAction<PaginationBounds>>;
}

const DocketFollowUpTableView = ({
  events,
  totalRecords,
  bounds,
  menuItems,
  handleTableChange,
  setBounds,
}: DocketFollowUpTableViewProps) => {
  return (
    <ScrollableTable
      data={events}
      dataRowElement={FollowUpItemTableRow}
      headerCells={headerCells}
      totalRecords={totalRecords}
      menuItems={menuItems}
      dispatchAction={handleTableChange}
      bounds={bounds}
      setBounds={setBounds}
    />
  );
};

export default DocketFollowUpTableView;
